import React, { useEffect, useState } from 'react'
import MainCard from '../../newTestPreo/components/MainCard'
import { Backdrop, Box, Button, Card, CardContent, CircularProgress, Divider, Grid, Paper, Stack, Typography, styled } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import { fDate } from '../../utils2/formatTime';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

const CustomIcon = styled('img')({
    width: '30px',
    height: '24px',
   // position: 'fixed',
   // top: 0,
   // left: 0,
    
  });

  

function ViewAttendance() {
    const navigate = useNavigate()
    const enquiryId = localStorage.getItem('enquiryId');
    const enquiryPersonalDetailId = localStorage.getItem(
      "enquiryPersonalDetailId"
    );
    const [activeClasses, setActiveClasses] = useState([])
    const [inActiveClasses, setInActiveClasses] = useState([])
    const [loading, setLoading] = useState(true);
    

    const handleViewMore = (row) => {

      // Handle the "View More" action here
    
  
      const url = `/attendance`;
      const newState = { classDetails: row };

      navigate(url, { state: newState });
  
  };

    useEffect(() => {
        
        setLoading(true);
        fetch(`${API_ENDPOINT}route/activeclass/${enquiryPersonalDetailId}`)
        .then((response) => {
            if (!response.ok) {
              if (response.status === 403) {
                setActiveClasses([]); 
              } else {
                navigate('/page404')
                throw new Error(`Request failed with status: ${response.status}`);
              }
            }
            return response.json();
          })
          .then((data) => {
        
            if (data) {
              setActiveClasses(data);
            }
          })
          .catch((error) => {
            console.error('Error fetching demos data:', error);
          })
          .finally(() => {
            setLoading(false);
          });
      }, []);

      useEffect(() => {
        
        setLoading(true);
        fetch(`${API_ENDPOINT}route/inactiveclass/${enquiryPersonalDetailId}`)
        .then((response) => {
            if (!response.ok) {
              if (response.status === 403) {
               
                setInActiveClasses([]); 
              } else {
                navigate('/page404')
                throw new Error(`Request failed with status: ${response.status}`);
              }
            }
            return response.json();
          })
          .then((data) => {
      
            if (data) {
              setInActiveClasses(data);
            }
          })
          .catch((error) => {
            console.error('Error fetching demos data:', error);
          })
          .finally(() => {
            setLoading(false);
          });
      }, []);
  return (
    <>
     <Backdrop open={loading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>Fetching</Typography>
        <CircularProgress color="primary" />
      </Backdrop>
    <Grid container spacing={2}>
    <Grid item xs={4} lg={3}>
      <Paper
        sx={{
          height: "50px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "24px",
        }}
      >
        <img src='/immigration.png' style={{ width: '40px', height: '36px' }} alt="Teacher" />
        <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
          View Attendance
        </Typography>
      </Paper>
    </Grid>
  </Grid>

  <Box m={2} />

  <MainCard>
  <Typography sx={{ color: '#000000', fontFamily: '"Inters-SemiBold", Helvetica', fontSize: '20px'}} fontWeight={800}>Active Classes</Typography>
<Box m={2}/>
      {activeClasses.length === 0 ? (
          <Typography variant="h4" color="error">
            No Active Classes
          </Typography>
        ) : (
              <Box>
                <Grid container spacing={4} >
                {activeClasses.map((classe, index) => (
             <Grid item xs ={6} lg={4}>
                <Card
                    variant="outlined"
                    sx={{
                        borderColor: 'black', // Replace 'your_border_color' with the color you want
                        borderWidth: '2px',
                        borderRadius: '30px' // Adjust the border width as needed
                    }}
                    >
            <CardContent>
            <Typography sx={{ color: '#019e6f', fontFamily: '"Inters-SemiBold", Helvetica', fontSize: '20px'}} fontWeight={800}>Class Details</Typography>
            <Divider />
            <Box mb={2}/>
            <Grid container spacing={4}>
            <Grid item xs={12}>
                
                <Stack direction='column' spacing={2}>
               
                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/virtual-event.png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '16px', marginLeft: '5px'}} fontWeight={400}>Class Name</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.class_id.name}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/package.png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '16px', marginLeft: '5px'}} fontWeight={400}>Sessions Purchased</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.package_days} sessions</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/appointment.png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '16px', marginLeft: '5px'}} fontWeight={400}>Start Date</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{fDate(classe.enrollment_date)}</Typography>
                    </Box>
                    </Stack>

                   

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/status.png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '16px', marginLeft: '5px'}} fontWeight={400}>Status</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.status_of_student}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction="row" justifyContent="space-evenly">
        {/* ... */}
        {classe.status_of_student === 'active' && (
          <Box>
           
              <Button variant="contained" color="secondary" onClick={() => handleViewMore(classe.id)} >
                View Attendance
              </Button>
           
          </Box>
        )}

      </Stack>
                   
                    </Stack>

               
            </Grid>
            </Grid>             
            </CardContent>
     </Card>
     </Grid>
                ))}
                </Grid>
                </Box>
        )}

        <Box m={2}/>

       
      {inActiveClasses.length !== 0 && (
        <>
         <Typography sx={{ color: '#000000', fontFamily: '"Inters-SemiBold", Helvetica', fontSize: '20px'}} fontWeight={800}>Previously Enrolled Classes</Typography>
         <Box m={2}/>
              <Box>
                <Grid container spacing={4} >
                {inActiveClasses.map((classe, index) => (
             <Grid item xs ={6} lg={4}>
                <Card
                    variant="outlined"
                    sx={{
                        borderColor: 'black', // Replace 'your_border_color' with the color you want
                        borderWidth: '2px',
                        borderRadius: '30px' // Adjust the border width as needed
                    }}
                    >
            <CardContent>
            <Typography sx={{ color: '#019e6f', fontFamily: '"Inters-SemiBold", Helvetica', fontSize: '20px'}} fontWeight={800}>Class Details</Typography>
            <Divider />
            <Box mb={2}/>
            <Grid container spacing={4}>
            <Grid item xs={12}>
                
                <Stack direction='column' spacing={2}>
               
                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/virtual-event.png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '16px', marginLeft: '5px'}} fontWeight={400}>Class Name</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.class_id.name}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/package.png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '16px', marginLeft: '5px'}} fontWeight={400}>Sessions Purchased</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.package_days} sessions</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/appointment.png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '16px', marginLeft: '5px'}} fontWeight={400}>Start Date</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{fDate(classe.enrollment_date)}</Typography>
                    </Box>
                    </Stack>

                   

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/status.png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '16px', marginLeft: '5px'}} fontWeight={400}>Status</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.status_of_student}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction="row" justifyContent="space-evenly">

      </Stack>
                   
                    </Stack>

               
            </Grid>
            </Grid>             
            </CardContent>
     </Card>
     </Grid>
                ))}
                </Grid>
                </Box>
                </>
        )}

  </MainCard>
  </>
  )
}

export default ViewAttendance